import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchClients } from '../../api/admin';

const initialState = {
  users: [],
  meta: {},
  filters: {
    email: '',
    name: '',
    status: '',
    role: '',
    email_verified: '',
  },
  page: 0,
  loading: false,
  error: '',
};

export const fetchUsersThunk = createAsyncThunk(
  'userManagement/fetchUsers',
  async ({ filters, page }, thunkApi) => {
    try {
      const state = thunkApi.getState();
      const { token } = state.adminAuth;
      const ITEMS_PER_PAGE = 20;
      const params = new URLSearchParams({
        ...(filters.search ? { search: filters.search } : {}),
        limit: ITEMS_PER_PAGE,
        offset: page * ITEMS_PER_PAGE,
      }).toString();
      const data = await fetchClients(token, params);
      return { users: data.users || [], meta: data.meta || {}, filters, page };
    } catch (err) {
      return thunkApi.rejectWithValue(err.message || 'Failed to fetch users');
    }
  }
);

const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    clearUsers: (state) => {
      state.users = [];
      state.meta = {};
      state.page = 0;
      state.loading = false;
      state.error = '';
    },
    updateUserApiKeyStatus: (state, action) => {
      const { userId, isActive } = action.payload;
      const user = state.users.find(u => u.id === userId);
      if (user && user.api_key) {
        user.api_key.disabled_by_admin = isActive;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersThunk.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchUsersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.users;
        state.meta = action.payload.meta;
        state.filters = action.payload.filters;
        state.page = action.payload.page;
        state.error = '';
      })
      .addCase(fetchUsersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilters, setPage, clearUsers, updateUserApiKeyStatus } = userManagementSlice.actions;
export const selectUsers = (state) => state.userManagement.users;
export const selectUserMeta = (state) => state.userManagement.meta;
export const selectUserFilters = (state) => state.userManagement.filters;
export const selectUserPage = (state) => state.userManagement.page;
export const selectUserLoading = (state) => state.userManagement.loading;
export const selectUserError = (state) => state.userManagement.error;

export default userManagementSlice.reducer; 